const ProfileStationsWithStats = ['Spieler', 'Trainer', 'Co-Trainer', 'Spielertrainer', 'spielender Co-Trainer'];

export {ProfileStationsWithStats};
